import React from "react";
import { Card, Placeholder } from "react-bootstrap";

const Skeleton = ({ skeletonType, count = 5 }) => {
  const arr = Array.from({ length: count }, (_, i) => i + 1);

  if (skeletonType === "PerformanceADRMonitor") {
    return (
      <table className="w-100">
        <tbody>
          <tr>
            {[...Array(6)].map((_, index) => (
              <td key={index} style={{ width: "16.66666666666667%" }}>
                <div className="flex-child align-middle allSettingsBox">
                  <div>
                    <Placeholder as="p" animation="glow" className="mb-2">
                      <Placeholder
                        style={{
                          height: "14px",
                          width: "60%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                  </div>
                  <div>
                    <Placeholder as="h6" animation="glow" className="mb-0">
                      <Placeholder
                        style={{
                          height: "24px",
                          width: "40%",
                          borderRadius: "6px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                  </div>
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    );
  } else if (skeletonType === "PerformanceADRMonitorCards") {
    return (
      <>
        <td
          style={{ width: "70%", verticalAlign: "top", paddingRight: "10px" }}
        >
          <table>
            <tbody>
              <tr>
                <td colSpan={2} style={{ paddingBottom: "8px" }}>
                  <div
                    className="flex-child text-center align-middle allSettingsBox m-0"
                    style={{
                      height: "92px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Placeholder as="p" animation="glow" className="mb-2 w-100">
                      <Placeholder
                        style={{
                          height: "14px",
                          width: "20%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                    <Placeholder
                      as="h3"
                      animation="glow"
                      className="mb-0 w-100"
                    >
                      <Placeholder
                        style={{
                          height: "30px",
                          width: "35%",
                          borderRadius: "6px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "50%", paddingRight: "4px" }}>
                  <div
                    className="flex-child text-center align-middle allSettingsBox ms-0"
                    style={{
                      height: "82px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Placeholder as="p" animation="glow" className="mb-2 w-100">
                      <Placeholder
                        style={{
                          height: "14px",
                          width: "40%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                    <Placeholder as="b" animation="glow" className="mb-0 w-100">
                      <Placeholder
                        style={{
                          height: "18px",
                          width: "30%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                  </div>
                </td>
                <td style={{ width: "50%", paddingLeft: "4px" }}>
                  <div
                    className="flex-child text-center align-middle allSettingsBox me-0"
                    style={{
                      height: "82px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Placeholder as="p" animation="glow" className="mb-2 w-100">
                      <Placeholder
                        style={{
                          height: "14px",
                          width: "40%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                    <Placeholder as="b" animation="glow" className="mb-0 w-100">
                      <Placeholder
                        style={{
                          height: "18px",
                          width: "30%",
                          borderRadius: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.25)",
                        }}
                      />
                    </Placeholder>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td style={{ width: "30%", verticalAlign: "top" }}>
          <div
            className="property-score-card d-flex flex-column align-items-center justify-content-center"
            style={{ height: "100%", minHeight: "182px", padding: "15px" }}
          >
            <div className="icon-and-title w-100 text-center mb-3">
              <Placeholder as="b" animation="glow" className="w-100">
                <Placeholder
                  style={{
                    height: "16px",
                    width: "60%",
                    borderRadius: "4px",
                    backgroundColor: "rgba(0, 0, 0, 0.25)",
                  }}
                />
              </Placeholder>
            </div>
            <div
              className="chartWrapper d-flex flex-column align-items-center justify-content-center position-relative w-100"
              style={{ height: "110px" }}
            >
              <Placeholder
                as="div"
                animation="glow"
                className="position-absolute"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <Placeholder
                  style={{
                    height: "90px",
                    width: "90px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 0, 0, 0.15)",
                  }}
                />
              </Placeholder>
              <Placeholder
                as="div"
                animation="glow"
                className="position-absolute"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                }}
              >
                <Placeholder
                  style={{
                    height: "65px",
                    width: "65px",
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                  }}
                />
              </Placeholder>
            </div>
          </div>
        </td>
      </>
    );
  } else if (skeletonType === "RmDashboard") {
    return (
      <>
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="allSettingsBox d-flex justify-content-between align-items-start"
          >
            <div className="allSettingsBoxContent" style={{ width: "100%" }}>
              <Placeholder as="p" animation="glow" className="mb-3">
                <Placeholder
                  style={{
                    height: "14px",
                    width: "45%",
                    borderRadius: "4px",
                    backgroundColor: "rgba(0, 0, 0, 0.25)",
                  }}
                />
              </Placeholder>
              <Placeholder as="p" animation="glow" className="mb-1">
                <Placeholder
                  style={{
                    height: "36px",
                    width: "65%",
                    borderRadius: "6px",
                    backgroundColor: "rgba(0, 0, 0, 0.25)",
                  }}
                />
              </Placeholder>
            </div>
            <div className="allSettingsBoxImg ms-2">
              <Placeholder as="div" animation="glow">
                <Placeholder
                  style={{
                    height: "28px",
                    width: "28px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 0, 0, 0.25)",
                  }}
                />
              </Placeholder>
            </div>
          </div>
        ))}
      </>
    );
  } else if (skeletonType === "PropertyOverviewCard") {
    return (
      <div className="allSettingsBox d-flex justify-content-between align-items-start h-100">
        <div className="allSettingsBoxContent" style={{ width: "100%" }}>
          <Placeholder as="p" animation="glow" className="mb-4">
            <Placeholder
              style={{
                height: "36px",
                width: "65%",
                borderRadius: "6px",
                backgroundColor: "rgba(0, 0, 0, 0.25)",
              }}
            />
          </Placeholder>
          <div className="footerForCardDashboard d-flex align-items-center gap-2">
            <Placeholder as="div" animation="glow" className="d-flex">
              <Placeholder
                style={{
                  height: "28px",
                  width: "28px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(0, 0, 0, 0.25)",
                }}
              />
            </Placeholder>
            <Placeholder
              as="p"
              animation="glow"
              className="mb-0 m-0 p-0"
              style={{ width: "45%" }}
            >
              <Placeholder
                style={{
                  height: "14px",
                  width: "100%",
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 0, 0, 0.25)",
                }}
              />
            </Placeholder>
          </div>
        </div>
      </div>
    );
  } else if (skeletonType === "DSDashboardCards") {
    return (
      <>
        {[...Array(7)].map((_, index) => (
          <div
            key={index}
            className="kpi-card"
            style={{
              padding: "12px",
              borderRadius: "8px",
              background: "rgba(53, 101, 252, 0.1)",
              border: "1px solid rgba(53, 101, 252, 0.2)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
              height: "102px",
            }}
          >
            <Placeholder as="div" animation="glow" className="w-100 mb-2">
              <Placeholder
                style={{
                  height: "14px",
                  width: "70%",
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 0, 0, 0.25)",
                }}
              />
            </Placeholder>
            <Placeholder as="div" animation="glow" className="w-100 mb-2">
              <Placeholder
                style={{
                  height: "24px",
                  width: "20%",
                  borderRadius: "6px",
                  backgroundColor: "rgba(0, 0, 0, 0.25)",
                }}
              />
            </Placeholder>
            <Placeholder as="div" animation="glow" className="w-100">
              <Placeholder
                style={{
                  height: "12px",
                  width: "80%",
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 0, 0, 0.25)",
                }}
              />
            </Placeholder>
          </div>
        ))}
      </>
    );
  } else if (skeletonType === "GroupWashCards") {
    return (
      <>
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="groupiq-summary-card"
            style={{
              padding: "15px",
              borderRadius: "4px",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #dce4ef",
              background: "#ebf0f9",
            }}
          >
            <Placeholder as="div" animation="glow" className="w-100 mb-2">
              <Placeholder
                style={{
                  height: "12px",
                  width: "60%",
                  borderRadius: "2px",
                  backgroundColor: "rgba(0, 0, 0, 0.15)",
                }}
              />
            </Placeholder>
            <Placeholder as="div" animation="glow" className="w-100 mb-2 mt-2">
              <Placeholder
                style={{
                  height: "28px",
                  width: "40%",
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 0, 0, 0.15)",
                }}
              />
            </Placeholder>
            <Placeholder as="div" animation="glow" className="w-100 mt-3">
              <Placeholder
                style={{
                  height: "12px",
                  width: "80%",
                  borderRadius: "2px",
                  backgroundColor: "rgba(0, 0, 0, 0.15)",
                }}
              />
            </Placeholder>
          </div>
        ))}
      </>
    );
  } else if (skeletonType === "NotificationList") {
    return (
      <>
        {arr.map((i) => (
          <div className="notification-card">
            <Card key={`skeleton-notif-${i}`} className="mb-2">
              <Card.Body className="m-0 p-0">
                <div className="notificationMain skeleton-card" aria-hidden>
                  <div
                    className="left-accent"
                    style={{ background: "transparent" }}
                  />
                  <div className="notification-wrapper">
                    <div className="notification-header d-flex justify-content-between align-items-center">
                      <div className="skeleton-chips d-flex">
                        <div className="skeleton-chip" />
                        <div className="skeleton-chip short" />
                        <div className="skeleton-chip medium" />
                      </div>
                      <div className="skeleton-date" />
                    </div>
                    <div className="notification-ttile-detail mt-2">
                      <div className="skeleton-line" />
                      <div className="skeleton-line short" />
                      <div className="skeleton-progress mt-2" />
                      <div style={{ height: 8 }} />
                      <div className="d-flex gap-2 mt-2">
                        <div className="skeleton-chip tiny" />
                        <div className="skeleton-chip tiny" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </>
    );
  }

  return null;
};

export default Skeleton;
